import { isFunction } from 'lodash';
import { MutableRefObject } from 'react';

type RefFunction<T> = (instance: T | null) => void;

// KU – React doesn't support specifying two refs for the same (DOM) component.
// shareRefs attempts to remedy this and should be used if a React
// component needs both an internal reference to a (DOM) component and an
// external one (e.g., a forwarded ref). The React component should pass
// both the external and internal refs to shareRefs. shareRefs returns a ref
// function that should be used by whatever (DOM) component needs two refs.

export function shareRefs<T>(
  ...sharedRefs: Array<RefFunction<T> | MutableRefObject<T | null> | null | undefined>
): RefFunction<T> {
  return function setRef(value: T | null) {
    sharedRefs.forEach(sharedRef => {
      if (isFunction(sharedRef)) {
        sharedRef(value);
      } else if (sharedRef) {
        // eslint-disable-next-line no-param-reassign
        sharedRef.current = value;
      }
    });
  };
}

export function preventDefault(e?: { preventDefault(): void }) {
  e?.preventDefault();
}
